import React from 'react';
import PageComponent from '../../components/providerSelection/ProviderSelectionPage';

const ProviderSelectionPage = () => {
  return <PageComponent />;
};

export { ProviderSelectionPage };
export default ProviderSelectionPage;
